import { PROGRESSIVE_SPEECH_LIMITS, type ProgressiveSpeechErrorCode } from "./progressiveSpeechProtocol.ts";

/** Explicit opt-in; complete-clip protocol 1 remains unchanged. */
export const INCREMENTAL_SPEECH_PROTOCOL = 2 as const;
export const INCREMENTAL_SPEECH_LIMITS = {
  ...PROGRESSIVE_SPEECH_LIMITS,
  chunkAudioBytes: 64 * 1024,
  chunkCount: 512,
  frameBytes: Math.ceil((64 * 1024) / 3) * 4 + 1024,
} as const;
export type IncrementalSpeechEvent =
  | { type: "start"; protocol: 2; clips: number }
  | { type: "audio"; protocol: 2; seq: number; part: number; audio_base64: string; cached: boolean; credit_balance_units: number | null }
  | { type: "clip_done"; protocol: 2; seq: number; parts: number }
  | { type: "done"; protocol: 2; clips: number }
  | { type: "error"; protocol: 2; code: ProgressiveSpeechErrorCode };
